import React from 'react';
import { Grid } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import EventIcon from '@mui/icons-material/Event';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WorkIcon from '@mui/icons-material/Work';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Section, InfoField, formatDate } from '../ViewPatientDialog.utils';

export default function OverviewTab({ patient }) {
  return (
    <>
      <Section icon={<PersonIcon />} title="Identité du patient" subtitle="Informations personnelles et administratives">
        <Grid container spacing={2}>
          <InfoField label="Nom" value={patient.nom_patient} />
          <InfoField label="Prénom" value={patient.prenom_patient} />
          <InfoField label="Email" value={patient.email_patient} icon={<EmailIcon fontSize="small" />} />
          <InfoField label="Téléphone" value={patient.telephone_patient} icon={<PhoneIcon fontSize="small" />} />
          <InfoField label="Date de naissance" value={formatDate(patient.date_naissance_patient)} icon={<EventIcon fontSize="small" />} />
          <InfoField label="Lieu de résidence" value={patient.lieu_residence_patient} icon={<LocationOnIcon fontSize="small" />} />
          <InfoField label="Profession" value={patient.profession_patient} icon={<WorkIcon fontSize="small" />} />
          <InfoField label="Statut professionnel" value={patient.statut_pro_patient} />
          <InfoField label="Situation familiale" value={patient.situation_familiale_patient} icon={<FamilyRestroomIcon fontSize="small" />} />
          <InfoField label="Nombre / âge des enfants" value={patient.enfants_age_patient} />
        </Grid>
      </Section>

      <Section icon={<PhoneIcon />} title="Personne de confiance" subtitle="Contact de confiance du patient">
        <Grid container spacing={2}>
          <InfoField label="Lien / Prénom" value={patient.personne_confiance_lien_prenom} />
          <InfoField label="Téléphone" value={patient.personne_confiance_tel} icon={<PhoneIcon fontSize="small" />} />
        </Grid>
      </Section>

      <Section icon={<InfoOutlinedIcon />} title="Parcours et relation avec SOA" subtitle="Origine de la connaissance et première prise en charge">
        <Grid container spacing={2}>
          <InfoField label="Comment le patient connaît SOA" value={patient.connaissance_soa} fullWidth multiline />
          <InfoField label="Date de première visite" value={formatDate(patient.premiere_visite_date)} icon={<EventIcon fontSize="small" />} />
          <InfoField label="Coordination principale" value={patient.coordination_principale} fullWidth multiline />
        </Grid>
      </Section>
    </>
  );
}